import Vue from "vue";
import { UPDATE_ADMIN_COMMON_STATUS } from ".././mutation.type";

const state = {
  status_store: {},
};

const mutations = {
  [UPDATE_ADMIN_COMMON_STATUS]: (state, { key, value }) => {
    Vue.set(state.status_store, key, value);
  },
};

export default {
  state,
  mutations,
};
